<template>
  <MButton v-bind="getBindValue" @click="onClick">
    <slot>{{ t('common.export') }}</slot>
  </MButton>
</template>

<script setup lang="ts">
  import { ComponentOptionsMixin, computed, unref } from 'vue';
  import { useAttrs } from '@mts-fe/hooks';
  import { omit } from '@mts-fe/utils';
  import { MButton } from '@mts/components/Button';
  import { t } from '@mts/hooks/web/useI18n';
  import { downloadFile } from '@mts/utils/file';
  import { MExportProps } from '..';

  /** 导出-按钮 */
  defineOptions({
    name: 'SyncExportBtn',
    extends: MButton as ComponentOptionsMixin,
    inheritAttrs: false,
  });

  const props = defineProps<MExportProps>();
  const attrs = useAttrs();
  const getBindValue = computed(() => ({
    ...unref(attrs),
    ...omit(props, ['path', 'params', 'axiosConfig', 'axiosOptions']),
  }));

  const onClick = async () =>
    downloadFile(
      props.path,
      typeof props.params == 'function' ? props.params() : props.params,
      props.axiosConfig,
      props.axiosOptions,
    );
</script>
